import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({
    className,
    type,
    startIcon,
    endIcon,
    ...props
}: React.ComponentProps<'input'> & {
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
}) {
    const size = (props as Record<string, unknown>)['data-size'] as string | undefined;

    const input = (
        <input
            type={type}
            data-slot="input"
            className={cn(
                'h-9 w-full min-w-0 rounded-md border border-neutral-200 bg-bg-surface px-3 text-sm text-text-primary transition-[border-color,box-shadow] duration-150 outline-none placeholder:text-neutral-400 hover:border-neutral-300 focus-visible:border-primary-300 focus-visible:shadow-[0_0_0_2px_var(--color-primary-100)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-bg-raised disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-text-primary dark:bg-bg-surface dark:border-border-default dark:hover:border-border-strong dark:focus-visible:border-primary-600 dark:focus-visible:shadow-[0_0_0_2px_var(--color-primary-900)] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-[size=sm]:h-8 data-[size=sm]:px-2.5 data-[size=sm]:text-[0.8125rem] data-[size=lg]:h-10 data-[size=lg]:px-3.5 data-[size=lg]:text-base',
                startIcon && 'pl-9 data-[size=sm]:pl-8 data-[size=lg]:pl-10',
                endIcon && 'pr-9 data-[size=sm]:pr-8 data-[size=lg]:pr-10',
                className,
            )}
            {...props}
        />
    );

    if (!startIcon && !endIcon) return input;

    return (
        <div className={cn('group/input-icon relative w-full', className)} data-size={size}>
            {startIcon && (
                <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-text-tertiary group-data-[size=sm]/input-icon:left-2.5 group-data-[size=lg]/input-icon:left-3.5 [&>svg:not([class*='size-'])]:size-4">
                    {startIcon}
                </span>
            )}
            {input}
            {endIcon && (
                <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-text-tertiary group-data-[size=sm]/input-icon:right-2.5 group-data-[size=lg]/input-icon:right-3.5 [&>svg:not([class*='size-'])]:size-4">
                    {endIcon}
                </span>
            )}
        </div>
    );
}

export { Input };
